module.exports = __webpack_public_path__ + "static/media/FlorianGraf_Close.6dd54a0f.svg";